import * as React from "react";
import {
  List,
  DataTable,
  BooleanField,
  SearchInput,
  BooleanInput,
  EditButton,
} from "react-admin";

const DistrictFilter = [
  <SearchInput source="name" alwaysOn />,
  <BooleanInput label="Visible" source="visible" />,
  <BooleanInput label="Activo" source="active" />,
];

const DistrictList = () => {
  return (
    <List
      title="Barrios"
      filters={DistrictFilter}
      sort={{ field: "name", order: "ASC" }}
    >
      <DataTable rowClick="show" bulkActionButtons={false}>
        <DataTable.Col source="name" label="Nombre" />
        <DataTable.NumberCol source="order" label="Orden" />
        <DataTable.Col source="visible" label="Visible">
          <BooleanField source="visible" label="Visible" />
        </DataTable.Col>
        <DataTable.Col source="active" label="Activo">
          <BooleanField source="active" label="Activo" />
        </DataTable.Col>
        <DataTable.Col>
          <EditButton />
        </DataTable.Col>
      </DataTable>
    </List>
  );
};

export default DistrictList;
